import React from 'react';
import { LayerWrapper, styled, useTheme } from '@vw-marketing/us-components';
import { applyCustomStylesToChildren } from '../utils';

interface LayerBoxProps {
  style?: React.CSSProperties;
  component?: keyof JSX.IntrinsicElements;
  className?: string;
  [key: string]: any;
}

const StyledWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== '$customStyles',
})<{ $customStyles?: React.CSSProperties }>`
  ${({ $customStyles }) => applyCustomStylesToChildren($customStyles)}
`;

export const LayerBox = React.forwardRef<HTMLDivElement, LayerBoxProps>(
  ({ children, style, ...rest }, ref) => {
    const theme = useTheme();
    const resolvedStyle = typeof style === 'function' ? style(theme) : style;

    return (
      <StyledWrapper ref={ref} $customStyles={resolvedStyle}>
        <LayerWrapper {...rest}>{children}</LayerWrapper>
      </StyledWrapper>
    );
  }
);

LayerBox.displayName = 'LayerBox';
